import Vue from 'vue'
import ApiConfig from './api_config'

export default {
  async deviceLog (deviceid, slave) {
    try {
      const result = await Vue.prototype.$http.get(`${ApiConfig.BASE_URL}/device/log/${deviceid}/${slave}`)
      return result.data.data
    } catch (error) {
      console.error(error)
      throw error
    }
  },
  async log () {
    try {
      const result = await Vue.prototype.$http.get(`${ApiConfig.BASE_URL}/device/device-log/today`) 
      return result.data.data
    } catch (error) {
      console.error(error)
      throw error
    }
  },
}
